module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/service-type/service-type.component.scss
// module id = ./client/app/service-type/service-type.component.scss
// module chunks = main